import { render, staticRenderFns } from "./RemoveAction.vue?vue&type=template&id=b88450fa&"
import script from "./RemoveAction.vue?vue&type=script&lang=js&"
export * from "./RemoveAction.vue?vue&type=script&lang=js&"
import style0 from "./RemoveAction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports